@if(notificationDesign && notificationData && rerenderFlag){
    <div appDynamicScale xmlns="http://www.w3.org/1999/html">
        <div class="w-full h-full flex justify-around items-center">
            <div class="grid-container max-h-full m-auto scaler"
                 [ngClass]="notificationDesign.positioning || 'text-on-bottom'">
                <div class="grid-cell cell-a flex items-center justify-around" [ngClass]="{
            'opacity-0': !showAll,
            'opacity-1': showAll
            }" >

                    @if (!notificationDesign?.isVideoNotification && notificationDesign.mediaUrl) {
                        <img
                                [src]="notificationDesign.mediaUrl"
                                (load)="rescale()"
                                class="w-full max-h-full object-contain"
                                alt="Notification Media"/>
                    } @else if(notificationDesign?.isVideoNotification && notificationDesign?.videoUrl){
                        <video class="w-full max-h-[80vh] object-contain" id="videoPlayer" autoplay (loadedmetadata)="rescale()">
                            <source [src]="notificationDesign.videoUrl"/>
                        </video>
                    }
                </div>
                <div class="grid-cell flex cell-b items-center justify-around">
                    <div>
                        <div [ngClass]="{
                'opacity-0': !showAll,
                'opacity-1': showAll
            }" class="">
                            <white-label-typography-preview [text]="showMessageString" [design]="notificationDesign.title">
                            </white-label-typography-preview>
                        </div>
                        <div [ngClass]="{
                'opacity-0': !showAll,
                'opacity-1': showAll
                }" class="">
                            <white-label-typography-preview [text]="notificationData.message" [design]="notificationDesign.message">
                            </white-label-typography-preview>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>

}
